var exports = {
  "k": "xaf9ae18d--0f9297--container",
  "T": "xaf9ae18d--0f9297--rate",
};

module.exports = exports;
